'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { BodyShort, Detail, HelpText } from '@navikt/ds-react';
import styles from './AttributtListe.module.css';
import Historikk from './Historikk';
import { store } from '@/app/_components/store/store';
import { getHistoriskeEndringer } from '@/components/attributt-med-tittel/AttributtMedTittel';
import { AnsettelsesDetaljer, ArbeidsforholdDetaljert } from '@/types/arbeidsforhold';
import { formatDate } from '@/utils/formatting/dato';
import { hjelpetekstAriaLabel } from '@/utils/formatting/tekst';
import classNames from 'classnames';
import dayjs from 'dayjs';
export type AttributtDef = {
  key: string;
  title: string;
  valgt: boolean;
  hjelpetekst?: React.ReactNode;
  getValue: (data: ArbeidsforholdDetaljert) => React.ReactNode;
  getHistorikk?: (detaljer: AnsettelsesDetaljer) => React.ReactNode;
};
const hentVerdi = (attributt: AttributtDef, data: ArbeidsforholdDetaljert, viseDetaljerForDato?: Date) => {
  const idag = formatDate(new Date().toString());
  if (!viseDetaljerForDato || formatDate(viseDetaljerForDato.toString()) === idag) return attributt.getValue(data);
  if (!attributt.getHistorikk) return null;
  const gjeldendeForDato = data.ansettelsesdetaljerhistorikk?.find(historikk => dayjs(viseDetaljerForDato).isAfter(dayjs(historikk.rapporteringsmaanedFra)));
  return gjeldendeForDato ? attributt.getHistorikk(gjeldendeForDato) : null;
};

/** Stablet visning av arbeidsforholdsdetaljer. Erstatter den brede tabellen på små skjermer. */
export default function AttributtListe(t0) {
  const $ = _c(16);
  const {
    data,
    grupper,
    visHistorikk: t1,
    viseDetaljerForDato,
    className
  } = t0;
  const visHistorikk = t1 === undefined ? false : t1;
  const {
    tekst
  } = store.useReducerState();
  let t2;
  if ($[0] !== className) {
    t2 = classNames(styles.liste, className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== data || $[3] !== grupper || $[4] !== tekst || $[5] !== visHistorikk || $[6] !== viseDetaljerForDato) {
    let t4;
    if ($[8] !== data || $[9] !== tekst || $[10] !== visHistorikk || $[11] !== viseDetaljerForDato) {
      t4 = (gruppe, gruppeIndex) => <dl className={styles.gruppe} key={gruppeIndex}>{gruppe.map(attributt => {
          const endringer = attributt.getHistorikk ? getHistoriskeEndringer({
            data,
            getValue: attributt.getValue,
            getHistorikk: attributt.getHistorikk
          }) : [];
          return <div className={classNames(styles.rad, !attributt.valgt && styles.ikkeValgt)} key={attributt.key}><Detail as="dt" className={styles.label}>{attributt.title}{attributt.hjelpetekst && <HelpText title={hjelpetekstAriaLabel(tekst, attributt.title)}>{attributt.hjelpetekst}</HelpText>}</Detail><BodyShort as="dd" className={styles.verdi}>{!attributt.valgt ? tekst.info.opplysningIkkeValgt : hentVerdi(attributt, data, viseDetaljerForDato) || tekst.info.ingenData}{visHistorikk && attributt.valgt && endringer.length > 0 && <Historikk endringer={endringer} getHistorikk={attributt.getHistorikk} />}</BodyShort></div>;
        })}</dl>;
      $[8] = data;
      $[9] = tekst;
      $[10] = visHistorikk;
      $[11] = viseDetaljerForDato;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t3 = grupper.map(t4);
    $[2] = data;
    $[3] = grupper;
    $[4] = tekst;
    $[5] = visHistorikk;
    $[6] = viseDetaljerForDato;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}